import React from 'react'

import moment from 'moment-timezone'

import CollegeVisit from '.'
import MonthEventContainer from '../MonthEventContainer'
import requiredPropTypes from './requiredPropTypes'

const renderTime = (startTime) => {
  const timeFormat = startTime.minutes() === 0 ? 'ha' : 'h:mma'
  return startTime.format(`${timeFormat} z`)
}

export default function MonthView(props) {
  const startTime = moment.tz(props.event.StartTime, moment.tz.guess())
  return (
    <CollegeVisit
      {...props}
      className="month"
      summary={
        <MonthEventContainer
          isVirtual={props.event.Virtual}
          allowRepLocationType={props.event.AllowRepLocationType}
        >
          {!props.event.AllDay && renderTime(startTime)} Visit - {props.event.HighSchoolName}
        </MonthEventContainer>
      }
    />
  )
}
MonthView.propTypes = requiredPropTypes
